import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
import HomePageFour from "./pages/HomePageFour";
import HomePageFive from "./pages/HomePageFive";
import HomePageSix from "./pages/HomePageSix";
import HomePageSeven from "./pages/HomePageSeven";
import EmailPage from "./pages/EmailPage";
import AddUserPage from "./pages/AddUserPage";
import AlertPage from "./pages/AlertPage";
import AssignRolePage from "./pages/AssignRolePage";
import AvatarPage from "./pages/AvatarPage";
import BadgesPage from "./pages/BadgesPage";
import ButtonPage from "./pages/ButtonPage";
import CalendarMainPage from "./pages/CalendarMainPage";
import CardPage from "./pages/CardPage";
import CarouselPage from "./pages/CarouselPage";
import ChatEmptyPage from "./pages/ChatEmptyPage";
import ChatMessagePage from "./pages/ChatMessagePage";
import ChatProfilePage from "./pages/ChatProfilePage";
import CodeGeneratorNewPage from "./pages/CodeGeneratorNewPage";
import CodeGeneratorPage from "./pages/CodeGeneratorPage";
import ColorsPage from "./pages/ColorsPage";
import ColumnChartPage from "./pages/ColumnChartPage";
import CompanyPage from "./pages/CompanyPage";
import CurrenciesPage from "./pages/CurrenciesPage";
import DropdownPage from "./pages/DropdownPage";
import ErrorPage from "./pages/ErrorPage";
import FaqPage from "./pages/FaqPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import FormLayoutPage from "./pages/FormLayoutPage";
import FormValidationPage from "./pages/FormValidationPage";
import FormPage from "./pages/FormPage";
import GalleryPage from "./pages/GalleryPage";
import ImageGeneratorPage from "./pages/ImageGeneratorPage";
import ImageUploadPage from "./pages/ImageUploadPage";
import InvoiceAddPage from "./pages/InvoiceAddPage";
import InvoiceEditPage from "./pages/InvoiceEditPage";
import InvoiceListPage from "./pages/InvoiceListPage";
import InvoicePreviewPage from "./pages/InvoicePreviewPage";
import KanbanPage from "./pages/KanbanPage";
import LanguagePage from "./pages/LanguagePage";
import LineChartPage from "./pages/LineChartPage";
import ListPage from "./pages/ListPage";
import MarketplaceDetailsPage from "./pages/MarketplaceDetailsPage";
import MarketplacePage from "./pages/MarketplacePage";
import NotificationAlertPage from "./pages/NotificationAlertPage";
import NotificationPage from "./pages/NotificationPage";
import PaginationPage from "./pages/PaginationPage";
import PaymentGatewayPage from "./pages/PaymentGatewayPage";
import PieChartPage from "./pages/PieChartPage";
import PortfolioPage from "./pages/PortfolioPage";
import PricingPage from "./pages/PricingPage";
import ProgressPage from "./pages/ProgressPage";
import RadioPage from "./pages/RadioPage";
import RoleAccessPage from "./pages/RoleAccessPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import StarRatingPage from "./pages/StarRatingPage";
import StarredPage from "./pages/StarredPage";
import SwitchPage from "./pages/SwitchPage";
import TableBasicPage from "./pages/TableBasicPage";
import TableDataPage from "./pages/TableDataPage";
import TabsPage from "./pages/TabsPage";
import TagsPage from "./pages/TagsPage";
import TermsConditionPage from "./pages/TermsConditionPage";
import TextGeneratorPage from "./pages/TextGeneratorPage";
import ThemePage from "./pages/ThemePage";
import TooltipPage from "./pages/TooltipPage";
import TypographyPage from "./pages/TypographyPage";
import UsersGridPage from "./pages/UsersGridPage";
import UsersListPage from "./pages/UsersListPage";
import ViewDetailsPage from "./pages/ViewDetailsPage";
import VideoGeneratorPage from "./pages/VideoGeneratorPage";
import VideosPage from "./pages/VideosPage";
import ViewProfilePage from "./pages/ViewProfilePage";
import VoiceGeneratorPage from "./pages/VoiceGeneratorPage";
import WalletPage from "./pages/WalletPage";
import WidgetsPage from "./pages/WidgetsPage";
import WizardPage from "./pages/WizardPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import TextGeneratorNewPage from "./pages/TextGeneratorNewPage";
import HomePageEight from "./pages/HomePageEight";
import HomePageNine from "./pages/HomePageNine";
import HomePageTen from "./pages/HomePageTen";
import HomePageEleven from "./pages/HomePageEleven";
import GalleryGridPage from "./pages/GalleryGridPage";
import GalleryMasonryPage from "./pages/GalleryMasonryPage";
import GalleryHoverPage from "./pages/GalleryHoverPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import AddBlogPage from "./pages/AddBlogPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import MaintenancePage from "./pages/MaintenancePage";
import BlankPagePage from "./pages/BlankPagePage";
import HomePageOld from "./pages/HomePageOld";
import PrivateRoute from "./utils/routes/PrivateRoute";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { SetUserData } from "./utils/redux/slices/authSlice";
import { refreshAccessToken } from "./utils/redux/slices/authSlice";
import { useSelector } from "react-redux";
import HomePageTwelve from "./pages/HomePageTwelve";
import HomePageTest from "./pages/HomePageTest";
import CenterReport from "./pages/CenterReport";
import UserFormPage from "./pages/UserFormPage.jsx";
import RoleManagement from "./pages/RoleManagement.jsx";
import ModuleManagement from "./pages/ModuleManagement.jsx";
import CenterDailyData from "./pages/CenterDailyData.jsx";
import { ConfigContext } from "./utils/ConfigContext.jsx";
import Cookies from "js-cookie";
import CustomCenterGroup from "./pages/CustomCenterGroup.jsx";
import CenterGroupOverview from "./pages/CenterGroupOverview.jsx";
import StateOverviewPage from "./pages/StateOverviewPage.jsx"
import ChangePassword from "./pages/ChangePassword.jsx";
import ResetPasswordPage from "./pages/ResetPasswordPage.jsx";
import PackageOverviewPage from "./pages/PackageOverviewPage.jsx";
import TreatmentOverviewPage from "./pages/TreatmentOverviewPage.jsx";
import TreatmentRevenueOverviewPage from "./pages/TreatmentRevenueOverviewPage.jsx";
import OpdComparisonPage from "./pages/OpdComparisonPage.jsx";
function App() {
  const [API_BASE_URL, setAPI_BASE_URL] = useState(null);

  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const dispatch = useDispatch();

  // when page load then save user data in redux store
  // useEffect(() => {

  //   fetch("/config.json")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setAPI_BASE_URL(data.API_URL);
  //     })
  //     .catch((err) => console.error("❌ Error loading config.json:", err));

  //   const userData = JSON.parse(localStorage.getItem("userData"));
  //   if (userData) {
  //     dispatch(SetUserData(userData));
  //   }
  //   // Check for refresh token on app load
  //   if (API_BASE_URL) {
  //   dispatch(refreshAccessToken(API_BASE_URL))
  //     .finally(() => setIsCheckingAuth(false));
  //     // setIsCheckingAuth(false);
  //   }
  // }, [dispatch,API_BASE_URL]);
  useEffect(() => {
    const initApp = async () => {
      try {
        // 1️⃣ Load API base URL
        const res = await fetch("/config.json");
        const data = await res.json();
        setAPI_BASE_URL(data.API_URL);

        // 2️⃣ Restore user data
        const userData = JSON.parse(localStorage.getItem("userData"));
        if (userData) {
          dispatch(SetUserData(userData));
        }

        // 3️⃣ Refresh token if refresh token exists
        const refreshToken = Cookies.get("refreshToken");
        if (refreshToken) {
          await dispatch(refreshAccessToken(data.API_URL)); // Wait for refresh
        }
      } catch (err) {
        console.error("❌ App init failed:", err);
      } finally {
        setIsCheckingAuth(false); // ✅ Only stop loading after all done
      }
    };

    initApp();
  }, [dispatch]);

  if (isCheckingAuth) {
    return (
      <div className="w-100 vh-100 d-flex align-items-center justify-content-center">
        <div className="loader"></div>
      </div>
    ); // Show a loading spinner or placeholder
  }
  return (
    <ConfigContext.Provider value={{ API_BASE_URL }}>
      <BrowserRouter>
        <RouteScrollToTop />
        <Routes>
          {/* <Route exact path='/old' element={<HomePageOld />} /> */}
          <Route exact path="/login" element={<SignInPage />} />
          <Route
            exact
            path="/"
            element={
              <PrivateRoute>
                <HomePageOne />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/center-report"
            element={
              <PrivateRoute>
                <CenterReport />
              </PrivateRoute>
            }
          />

          {/* <Route
            exact
            path="/center-daily-report"
            element={
              <PrivateRoute>
                <HomePageEight />
              </PrivateRoute>
            }
          /> */}
          <Route
            exact
            path="/center-daily-data"
            element={
              <PrivateRoute>
                <CenterDailyData />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/index-12"
            element={
              <PrivateRoute>
                <HomePageTwelve />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/doctor_revenue"
            element={
              <PrivateRoute>
                <HomePageTest />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/users/create"
            element={
              <PrivateRoute>
                <UserFormPage mode='Add' />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/users/:id/edit"
            element={
              <PrivateRoute>
                <UserFormPage mode = 'Edit' />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/users"
            element={
              <PrivateRoute>
                 <UsersListPage />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/roles"
            element={
              <PrivateRoute>
                <RoleManagement />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/modules-management"
            element={
              <PrivateRoute>
                <ModuleManagement />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/center-group"
            element={
              <PrivateRoute>
                <CustomCenterGroup />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/center-group-overview"
            element={
              <PrivateRoute>
                <CenterGroupOverview />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/center-state-overview"
            element={
              <PrivateRoute>
                <StateOverviewPage />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/center-package-overview"
            element={
              <PrivateRoute>
                <PackageOverviewPage />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/center-treatment-overview"
            element={
              <PrivateRoute>
                <TreatmentOverviewPage />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/center-treatment-revenue-overview"
            element={
              <PrivateRoute>
                <TreatmentRevenueOverviewPage />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/center-opd-comparison"
            element={
              <PrivateRoute>
                <OpdComparisonPage />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/change-password"
            element={
              <PrivateRoute>
                <ChangePassword />
              </PrivateRoute>
            }
          />
          <Route exact path='/forgot-password' element={<ForgotPasswordPage />} />
          <Route exact path='/reset-password' element={<ResetPasswordPage />} />

          
          <Route exact path="/index-2" element={<HomePageTwo />} />
          <Route exact path="/index-3" element={<HomePageThree />} />
          <Route exact path="/index-4" element={<HomePageFour />} />
          <Route exact path="/index-5" element={<HomePageFive />} />
          <Route exact path="/index-7" element={<HomePageSeven />} />
          <Route exact path="/index-9" element={<HomePageNine />} />
          <Route exact path="/index-10" element={<HomePageTen />} />
          <Route exact path="/index-11" element={<HomePageEleven />} />

          {/* SL
        
        <Route exact path='/alert' element={<AlertPage />} />
        <Route exact path='/assign-role' element={<AssignRolePage />} />
        <Route exact path='/avatar' element={<AvatarPage />} />
        <Route exact path='/badges' element={<BadgesPage />} />
        <Route exact path='/button' element={<ButtonPage />} />
        <Route exact path='/calendar-main' element={<CalendarMainPage />} />
        <Route exact path='/calendar' element={<CalendarMainPage />} />
        <Route exact path='/card' element={<CardPage />} />
        <Route exact path='/carousel' element={<CarouselPage />} />
        <Route exact path='/chat-empty' element={<ChatEmptyPage />} />
        <Route exact path='/chat-message' element={<ChatMessagePage />} />
        <Route exact path='/chat-profile' element={<ChatProfilePage />} />
        <Route exact path='/code-generator' element={<CodeGeneratorPage />} />
        <Route
          exact
          path='/code-generator-new'
          element={<CodeGeneratorNewPage />}
        />
        <Route exact path='/colors' element={<ColorsPage />} />
        <Route exact path='/column-chart' element={<ColumnChartPage />} />
        <Route exact path='/company' element={<CompanyPage />} />
        <Route exact path='/currencies' element={<CurrenciesPage />} />
        <Route exact path='/dropdown' element={<DropdownPage />} />
        <Route exact path='/email' element={<EmailPage />} />
        <Route exact path='/faq' element={<FaqPage />} />
        <Route exact path='/forgot-password' element={<ForgotPasswordPage />} />
        <Route exact path='/form-layout' element={<FormLayoutPage />} />
        <Route exact path='/form-validation' element={<FormValidationPage />} />
        <Route exact path='/form' element={<FormPage />} />

        <Route exact path='/gallery' element={<GalleryPage />} />
        <Route exact path='/gallery-grid' element={<GalleryGridPage />} />
        <Route exact path='/gallery-masonry' element={<GalleryMasonryPage />} />
        <Route exact path='/gallery-hover' element={<GalleryHoverPage />} />

        <Route exact path='/blog' element={<BlogPage />} />
        <Route exact path='/blog-details' element={<BlogDetailsPage />} />
        <Route exact path='/add-blog' element={<AddBlogPage />} />

        <Route exact path='/testimonials' element={<TestimonialsPage />} />
        <Route exact path='/coming-soon' element={<ComingSoonPage />} />
        <Route exact path='/access-denied' element={<AccessDeniedPage />} />
        <Route exact path='/maintenance' element={<MaintenancePage />} />
        <Route exact path='/blank-page' element={<BlankPagePage />} />

        <Route exact path='/image-generator' element={<ImageGeneratorPage />} />
        <Route exact path='/image-upload' element={<ImageUploadPage />} />
        <Route exact path='/invoice-add' element={<InvoiceAddPage />} />
        <Route exact path='/invoice-edit' element={<InvoiceEditPage />} />
        <Route exact path='/invoice-list' element={<InvoiceListPage />} />
        <Route exact path='/invoice-preview' element={<InvoicePreviewPage />} />
        <Route exact path='/kanban' element={<KanbanPage />} />
        <Route exact path='/language' element={<LanguagePage />} />
        <Route exact path='/line-chart' element={<LineChartPage />} />
        <Route exact path='/list' element={<ListPage />} />
        <Route
          exact
          path='/marketplace-details'
          element={<MarketplaceDetailsPage />}
        />
        <Route exact path='/marketplace' element={<MarketplacePage />} />
        <Route
          exact
          path='/notification-alert'
          element={<NotificationAlertPage />}
        />
        <Route exact path='/notification' element={<NotificationPage />} />
        <Route exact path='/pagination' element={<PaginationPage />} />
        <Route exact path='/payment-gateway' element={<PaymentGatewayPage />} />
        <Route exact path='/pie-chart' element={<PieChartPage />} />
        <Route exact path='/portfolio' element={<PortfolioPage />} />
        <Route exact path='/pricing' element={<PricingPage />} />
        <Route exact path='/progress' element={<ProgressPage />} />
        <Route exact path='/radio' element={<RadioPage />} />
        <Route exact path='/role-access' element={<RoleAccessPage />} />
        <Route exact path='/sign-up' element={<SignUpPage />} />
        <Route exact path='/star-rating' element={<StarRatingPage />} />
        <Route exact path='/starred' element={<StarredPage />} />
        <Route exact path='/switch' element={<SwitchPage />} />
        <Route exact path='/table-basic' element={<TableBasicPage />} />
        <Route exact path='/table-data' element={<TableDataPage />} />
        <Route exact path='/tabs' element={<TabsPage />} />
        <Route exact path='/tags' element={<TagsPage />} />
        <Route exact path='/terms-condition' element={<TermsConditionPage />} />
        <Route
          exact
          path='/text-generator-new'
          element={<TextGeneratorNewPage />}
        />
        <Route exact path='/text-generator' element={<TextGeneratorPage />} />
        <Route exact path='/theme' element={<ThemePage />} />
        <Route exact path='/typography' element={<TypographyPage />} />
        <Route exact path='/users-grid' element={<UsersGridPage />} />
        <Route exact path='/users-list' element={<UsersListPage />} />
        <Route exact path='/view-details' element={<ViewDetailsPage />} />
        <Route exact path='/video-generator' element={<VideoGeneratorPage />} />
        <Route exact path='/videos' element={<VideosPage />} />
        <Route exact path='/view-profile' element={<ViewProfilePage />} />
        <Route exact path='/voice-generator' element={<VoiceGeneratorPage />} />
        <Route exact path='/wallet' element={<WalletPage />} />
        <Route exact path='/widgets' element={<WidgetsPage />} />
        <Route exact path='/wizard' element={<WizardPage />} /> */}
          <Route exact path="/tooltip" element={<TooltipPage />} />

          <Route exact path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </ConfigContext.Provider>
  );
}

export default App;
